import { BookOpen } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';
import { Heading } from 'shared/components/Heading';
import { SHOW_LISTENERS_AND_RATINGS } from 'shared/constants/common';
import { useScrollReveal } from 'shared/hooks/useScrollReveal';

export function IntroductionSection() {
  const { t } = useTranslation('home');
  const image = useScrollReveal({ animation: 'fade-image' });
  const heading = useScrollReveal({ animation: 'float-up', delay: 0 });
  const paragraphs = useScrollReveal({ animation: 'float-up', delay: 120 });
  const stat1 = useScrollReveal({ animation: 'float-up', delay: 240 });
  const stat2 = useScrollReveal({ animation: 'float-up', delay: 360 });

  return (
    <section className="py-16 md:py-32 px-6 lg:px-24 bg-surface-container-lowest relative">
      <div className="grid md:grid-cols-12 gap-16 items-center max-w-7xl mx-auto">
        <div ref={image.ref} style={image.style} className="md:col-span-5 relative">
          <div className="aspect-[4/5] bg-surface-container-high rounded-2xl overflow-hidden shadow-2xl transform -rotate-3 hover:rotate-0 transition-transform duration-500">
            <img
              src="/images/home-mythology-art.jpg"
              alt={t('introduction.imageAlt')}
              className="w-full h-full object-cover opacity-80"
            />
          </div>
          <div className="absolute -bottom-10 -right-10 bg-tertiary p-8 rounded-xl shadow-xl hidden md:block">
            <BookOpen size={48} className="text-on-tertiary" />
          </div>
        </div>

        <div className="md:col-span-7">
          <Heading variant="section" innerRef={heading.ref} style={heading.style} className="mb-8">
            {t('introduction.heading')}
          </Heading>
          <div ref={paragraphs.ref} style={paragraphs.style} className="space-y-6 text-on-surface-variant font-sans text-lg leading-relaxed">
            <p>{t('introduction.paragraph1')}</p>
            <p>{t('introduction.paragraph2')}</p>
          </div>
          {SHOW_LISTENERS_AND_RATINGS ? <div className="mt-12 flex gap-12">
            <div ref={stat1.ref} style={stat1.style}>
              <div className="text-3xl font-serif text-tertiary">{t('introduction.monthlyListenersCount')}</div>
              <div className="text-xs uppercase tracking-widest font-sans opacity-80">
                {t('introduction.monthlyListenersLabel')}
              </div>
            </div>
            <div ref={stat2.ref} style={stat2.style}>
              <div className="text-3xl font-serif text-tertiary">{t('introduction.appleRatingValue')}</div>
              <div className="text-xs uppercase tracking-widest font-sans opacity-80">
                {t('introduction.appleRatingLabel')}
              </div>
            </div>
          </div> : null}
        </div>
      </div>
    </section>
  );
}
